import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/app/layouts/default.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/app/layouts/empty.vue").then(m => m.default || m))
}